import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { MenuCard } from "../../menu/MenuCard";
import { DisplayMode, TranslatedStringActionDetail } from "./components/TranslatedStringActionDetail";
import { AnimationSelectionDetail } from "./components/AnimationSelectionDetail";
import { InputWithMargin } from "../../editor/Input";
import { AnimationPropertiesValueModel } from "../../../../shared/action/ValueModel";
import { DirectionSelectionDetail } from "./components/DirectionSelectionDetail";
import { Dropdown } from "../../editor/Dropdown";
import { Slider, SliderThumb, SliderTrack } from "../../editor/Slider";
import { TextFormatInfoPopup } from "../TextFormatInfoPopup";
import { CutSceneTextModel } from "../../../../shared/action/CutSceneTextModel";
import { FaPlus } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { ElementGroupContainer } from "./components/BaseElements";
const Container = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__Container",
  componentId: "sc-xr0d39-0"
})(["min-width:320px;"]);
const SubContainer = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__SubContainer",
  componentId: "sc-xr0d39-1"
})(["margin:4px;margin-left:8px;"]);
const TopMargin = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__TopMargin",
  componentId: "sc-xr0d39-2"
})(["margin-top:4px;"]);
const MarginRow = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__MarginRow",
  componentId: "sc-xr0d39-3"
})(["display:flex;flex-direction:row;margin-top:4px;align-items:center;"]);
const Row = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__Row",
  componentId: "sc-xr0d39-4"
})(["display:flex;flex-direction:row;align-items:center;"]);
const OptionsContainer = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__OptionsContainer",
  componentId: "sc-xr0d39-5"
})(["display:flex;flex-direction:row;margin-top:12px;margin-left:8px;margin-bottom:8px;"]);
const RowLabel = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__RowLabel",
  componentId: "sc-xr0d39-6"
})(["min-width:100px;cursor:pointer;"]);
const TextItemContainer = styled(ElementGroupContainer).withConfig({
  displayName: "SimpleCutSceneActionDetails__TextItemContainer",
  componentId: "sc-xr0d39-7"
})([""]);
const Label = styled.label.withConfig({
  displayName: "SimpleCutSceneActionDetails__Label",
  componentId: "sc-xr0d39-8"
})(["flex-shrink:0;flex-grow:1;"]);
const ShrinkContainer = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__ShrinkContainer",
  componentId: "sc-xr0d39-9"
})(["display:flex;flex-direction:column;flex-grow:0;flex-shrink:1;"]);
const Button = styled.button.withConfig({
  displayName: "SimpleCutSceneActionDetails__Button",
  componentId: "sc-xr0d39-10"
})(["cursor:pointer;margin:4px;display:flex;align-items:center;"]);
const GrowContainer = styled.div.withConfig({
  displayName: "SimpleCutSceneActionDetails__GrowContainer",
  componentId: "sc-xr0d39-11"
})(["display:flex;flex-direction:column;flex-grow:1;flex-shrink:0;margin-left:20px;"]);
export const SimpleCutSceneActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();

  function onClickToggleText() {
    if (action.textItems) action.setTextItems(null);else action.setTextItems([new CutSceneTextModel({})]);
  }

  function onClickToggleLoop() {
    action.animation.setLoop(!action.animation.loop);
  }

  function onClickTextStyle(styleValue, itemIndex) {
    action.textItems[itemIndex].setTextStyle(styleValue);
  }

  function onClickToggleTypeAnimation(itemIndex) {
    action.textItems[itemIndex].setEnabledTypeAnimation(!action.textItems[itemIndex].enabledTypeAnimation);
  }

  function onClickDirection(direction, itemIndex) {
    action.textItems[itemIndex].setTextContainerAlignmentDirection(direction);
  }

  function onClickToggleAnimation() {
    if (action.animation) action.setAnimation(null);else action.setAnimation(new AnimationPropertiesValueModel({}));
  }

  function onClickAddText() {
    action.addTextItem();
  }

  function onClickDeleteTextItem(itemIndex) {
    action.removeTextItem(itemIndex);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MarginRow, null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.textItems != null,
    onChange: onClickToggleText
  }), t("action_editor.node_cut_scene_text")), /*#__PURE__*/React.createElement(TextFormatInfoPopup, {
    showTextStyleOptions: false
  })), action.textItems && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickAddText
  }, /*#__PURE__*/React.createElement(FaPlus, null), "\xA0", t("action_editor.node_cut_scene_add_text")), action.textItems.map((item, index) => /*#__PURE__*/React.createElement(TextItemContainer, {
    key: index
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Label, null, index + 1 + ". " + t("action_editor.node_cut_scene_text_item_headline")), action.textItems.length > 1 && /*#__PURE__*/React.createElement(Button, {
    onClick: _ => onClickDeleteTextItem(index)
  }, /*#__PURE__*/React.createElement(AiFillDelete, null))), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    key: index,
    name: "",
    translatedString: item.text,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(OptionsContainer, null, /*#__PURE__*/React.createElement(ShrinkContainer, null, /*#__PURE__*/React.createElement(DirectionSelectionDetail, {
    initialDirection: item.textContainerAlignmentDirection,
    onSelectionChange: direction => {
      onClickDirection(direction, index);
    }
  })), /*#__PURE__*/React.createElement(GrowContainer, null, /*#__PURE__*/React.createElement(Label, null, t("action_editor.node_cut_scene_text_style")), /*#__PURE__*/React.createElement(Dropdown, {
    value: item.textStyle ? "1" : "0",
    onChange: e => onClickTextStyle(e.target.value === "1" ? 1 : 0, index)
  }, /*#__PURE__*/React.createElement("option", {
    value: "1"
  }, t("action_editor.node_cut_scene_text_style_black_white")), /*#__PURE__*/React.createElement("option", {
    value: "0"
  }, t("action_editor.node_cut_scene_text_style_white_black"))), /*#__PURE__*/React.createElement(TopMargin, null, /*#__PURE__*/React.createElement(Label, null, t("action_editor.node_cut_scene_text_width") + " " + item.textContainerWidthPercent + "%"), /*#__PURE__*/React.createElement(Slider, {
    value: item.textContainerWidthPercent,
    min: 10,
    max: 100,
    step: 1,
    renderTrack: SliderTrack,
    renderThumb: SliderThumb,
    onChange: value => item.setTextContainerWidthPercent(value)
  })), /*#__PURE__*/React.createElement(TopMargin, null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: item.enabledTypeAnimation,
    onChange: e => onClickToggleTypeAnimation(index)
  }), t("action_editor.node_cut_scene_type_animation"))))))))), /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(MarginRow, {
    onClick: onClickToggleAnimation
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.animation != null,
    onChange: e => {}
  }), /*#__PURE__*/React.createElement(Label, null, t("action_editor.node_cut_scene_animation"))), action.animation && /*#__PURE__*/React.createElement(SubContainer, null, /*#__PURE__*/React.createElement(AnimationSelectionDetail, {
    animationProp: action.animation
  }), /*#__PURE__*/React.createElement(MarginRow, {
    onClick: onClickToggleLoop
  }, /*#__PURE__*/React.createElement(RowLabel, null, t("action_editor.property_animation_loop")), /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.animation.loop,
    onChange: e => {}
  })))));
});